import usePrivateAxios from '@/common/api/usePrivateAxios';
import { defaultTransformerResponse } from '@/common/constants/defaultTransformerResponse.constant';
import { BulkActionGlobalColumnsValidationSchema } from '@/common/schemas/bulkActions/globalColumns.schema';
import { Mapper } from '@/common/services/mapper';
import { MetaResponse } from '@/common/types/metaResponse';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

type UseBulkActionsEntriesMyLatestInProgressProps<T> = {
  filters?: {
    actionerKlass?: string;
    timeZone?: string;
    globalColumns?: BulkActionGlobalColumnsValidationSchema;
  };
  mapper?: (data: any) => T;
};

export const useBulkActionsEntriesMyLatestInProgress = <T,>({
  filters: { actionerKlass, timeZone, globalColumns } = {},
  mapper = Mapper.default<T>(),
}: UseBulkActionsEntriesMyLatestInProgressProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    enabled: !!actionerKlass,
    queryKey: ['bulkActionsEntriesMyLatestInProgress', actionerKlass, ...(globalColumns ? Object.values(globalColumns) : [])],
    queryFn: () => {
      return privateAxios.post('/bulk_actions/entries/my_latest_in_progress', {
        q: {
          actioner_klass_eq: actionerKlass,
          options_eq: {
            time_zone: timeZone,
            global_columns: globalColumns,
          },
        },
      });
    },
    select: (data: { data: { data: any[]; meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, ...rest };
};
